/* eslint-disable @typescript-eslint/no-misused-promises */
// import EntypoIcon from 'react-native-vector-icons/Entypo'
import BaseUISelectedSubscriptionPackageView from 'xui/modules/subscription/BaseUISelectedSubscriptionPackageView'
// import { Subscriptions } from 'xui/modules/subscription/Subscriptions'

export default class SelectedSubscriptionPackageView extends BaseUISelectedSubscriptionPackageView {
  static displayName = 'SelectedSubscriptionPackageView'
}
